import { useEffect, useState } from 'react';
import { SIMPLE_CARD } from 'src/sections/GroupCards/cardTypes';
import { dataToConsolidationSchema } from 'src/sections/GroupCards/SimpleChartCard/consolidation/utils';
import { isNullOrEmptyArray } from 'src/util/arrays';

/**
 * O intúito desse hook é abstrair a recuperação das consolidações dada
 * uma resposta da requisição dos resultados para um gráfico específico.
 * Esse resultado pode ter consolidação, e esse hook se preocupa em recuperar
 * apenas as informações relevantes relacionadas à consolidação. Pois posteriormente
 * será utilizado tanto no componente de consolidação quanto nos gerenciadores de temáticas
 * para aplicação de regras relacionadas a cores.
 *
 * @param {Array<object>} data Resultados de um gráfico para um cliente, pesquisa e pergunta
 * @param {string} cardType Tipo do card aplicado, consolidação poderá ser implementada
 * em outros tipos de cards futuramente.
 * @returns {Array<object>} consolidações que serão utilizadas
 */
export const useConsolidations = function (data, cardType = SIMPLE_CARD) {
  const [fromServerConsolidations, setFromServerConsolidations] = useState([]);

  useEffect(() => {
    if (!isNullOrEmptyArray(data)) {
      const consolidationsFromAlts = dataToConsolidationSchema(data);

      setFromServerConsolidations(consolidationsFromAlts);
    }
  }, [data]);

  return fromServerConsolidations;
};
